<template>
  <div class="product-main">
    <CollapseView :tabKeys="tabs" @y="scrollY">
      <div slot="header">
        <div class="title">
          <div class="flex">
            <a-button
              style="margin: 0 7px 0 0"
              type="primary"
              v-acl="'page_device_add_device'"
              @click="createEdit()"
            >
              <a-icon type="plus" style="font-size: 16px" />
              {{ $t("page_device_add_device") }}
            </a-button>
            <a-button
              style="margin: 0 7px 0 7px"
              @click="createEdit('edit')"
              :disabled="!selectedRowKeys.length || selectedRowKeys.length > 1"
              v-acl="'edit'"
              >{{ $t("edit") }}</a-button
            > 
            <a-button v-acl="'page_device_export'" @click="exportDevices" style="margin: 0 7px 0 7px">{{
              $t("page_device_export")
            }}</a-button>
            <a-button
              style="margin: 0 7px 0 7px"
              @click="print('a')"
              :disabled="!selectedRowKeys.length"
              >{{ $t("page_print_code") }}</a-button
            >
          </div>
          <div class="flex" style="margin-right: 8px">
            <app-select
              class="top-select"
              :list="newTypeList"
              v-model="typeId"
              @changeSelect="handleTypeChange"
              :allowClear="false"
            />
            <a-input-search
              v-acl="'page_product_search'"
              :placeholder="$t('common_please_input') + $t('keyword')"
              v-model="keyWords"
              allowClear
              @search="searchForm"
              :enterButton="$t('search')"
            />
          </div>
        </div>
      </div>
      <div slot="default" style="height: 100%">
        <div class="table-panel">
          <ml-table
            :columns="showColumns"
            :dataSource="dataList"
            rowKey="id"
            :rowSelection="{
              selectedRowKeys,
              onChange: this.onSelectChange,
              onSelect: this.onSelect,
              onSelectAll: this.onSelectAll,
            }"
            :canChangeColWidth="true"
            :scroll="{ x: tableScrollWidth, y: tableScrollY }"
            :custom-row="rowClick"
            :selectRowKey="deviceId"
          >
            <template slot="maintenance" slot-scope="text, record">
              <a
                @click="openMaintenanceProgram($event, record)"
                v-acl="'page_device_see_maintain'"
                >{{ $t("page_device_see") }}</a
              >
            </template>
            <template slot="SpotCheck" slot-scope="text, record">
              <a
                @click="openSpotCheckProgram($event, record)"
                v-acl="'page_device_see_spotcheck'"
                >{{ $t("page_device_see") }}</a
              >
            </template>
            <template slot="picture" slot-scope="text, record">
              <a
                @click="openPictureProgram($event, record)"
                v-acl="'page_device_see_picture'"
                >{{ $t("page_device_see") }}</a
              >
            </template>
          </ml-table>
          <a-pagination
          style="float:right;margin-top:10px;margin-right:20px;"
          :total="pagination.total"
          :showTotal="total => `${totalFanyi(total)}`"
          :pageSize="pagination.pageSize"
          :current="pagination.current"
          @change="pageIndexchange"
        ></a-pagination>
        </div>
      </div>
      <IndexEdit
        ref="Edit"
        :shows="shows"
        :visible="visible"
        :typeList="typeList"
        :typeId="typeId"
        :type="modalType"
        :record="editItem"
        @close="closeModal"
      />
      <IndexPrint
        :visible="showCode"
        :dataList="dataListArr"
        @print="print"
        @cancel="cancel"
      />
      <MaintenanceProgram
        ref="MaintenanceProgram"
        :typeList="typeList"
        :typeId="typeId"
        :visible="MaintenanceVisible"
        @closeMaintenance="closeMaintenanceProgram"
        :maintenanceId="maintenanceId"
      />
      <SpotCheckProgram
        ref="SpotCheckProgram"
        :typeList="typeList"
        :typeId="typeId"
        :visible="SpotCheckProgramVisible"
        @closeSpotCheck="closeSpotCheckProgram"
        :spotCheckId="spotCheckId"
      />
      <PictureProgram
        ref="PictureProgram"
        :visible="PictureProgramVisible"
        :workStationId="workStationId"
        @closePicture="closePictureProgram"
      />
      <div slot="footer">
        <IndexRepair :deviceId="deviceId" :deviceTypeId="typeId" />
        <IndexMaintenanceRecords :deviceId="deviceId" />
        <IndexMaintenancePlan :deviceId="deviceId" />
        <IndexSpotCheck :deviceId="deviceId" />
        <IndexSpareParts
          :deviceId="deviceId"
          :sparePartCode="sparePartCode"
          :sparePartName="sparePartName"
          :sparePartType="sparePartType"
        />
      </div>
    </CollapseView>
  </div>
</template>

<script>
import IndexEdit from "./components/indexEdit";
import IndexPrint from "@/components/CodeModel/index";
import IndexRepair from "./components/indexRepair";
import IndexMaintenanceRecords from "./components/indexMaintenanceRecords.tsx";
import IndexMaintenancePlan from "./components/indexMaintenancePlan.tsx";
import IndexSpotCheck from "./components/indexSpotCheck";
import IndexSpareParts from "./components/indexSpareParts";
import MaintenanceProgram from "./components/indexView/maintenanceProgram";
import SpotCheckProgram from "./components/indexView/SpotCheckProgram";
import PictureProgram from "./components/indexView/PictureProgram";
import {
  DeviceServiceProxy,
  DeviceTypeServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";
import dayjs from "dayjs";
import { downloadFile } from "@/utils/index";
import { exportDevice } from "@/api/api.ts";
import { getLocalStorage } from '@/utils/storage';
const deviceServiceProxy = new DeviceServiceProxy();
const deviceTypeServiceProxy = new DeviceTypeServiceProxy();
export default {
  components: {
    IndexEdit,
    IndexRepair,
    IndexMaintenanceRecords,
    IndexMaintenancePlan,
    IndexSpotCheck,
    IndexSpareParts,
    MaintenanceProgram,
    SpotCheckProgram,
    PictureProgram,
    IndexPrint,
  },
  name: "index",
  data() {
    return {
      dataListArr:[],
      showCode: false,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
      deviceId: "",
      keyWords: "",
      deviceList: [],
      // showColumns,
      tabs: [],
      newTypeList: [],
      typeList: [],
      typeId: "",
      shows: true,
      visible: false,
      MaintenanceVisible: false,
      SpotCheckProgramVisible: false,
      PictureProgramVisible: false,
      dataList: [],
      tableScrollWidth: 1700,
      tableScrollY: 250,
      resizeTimer: null,
      selectedRowKeys: [],
      modalType: "add", // 模态框是新增还是编辑
      editItem: {},
      workStationId: "",
      maintenanceId: "",
      spotCheckId: "",
      localTime: "",
      exportTypeId: [],
      sparePartCode: "",
      sparePartName: "",
      sparePartType: "",
    };
  },
  computed: {
    showColumns() {
      return [
        {
          title: this.$t("page_business_maintenance"),
          dataIndex: "maintenance",
          scopedSlots: { customRender: "maintenance" },
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_business_spot_check"),
          dataIndex: "SpotCheck",
          scopedSlots: { customRender: "SpotCheck" },
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_picture_jian"),
          dataIndex: "picture",
          scopedSlots: { customRender: "picture" },
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_plan_maintenance_equipment_coding_jian"),
          dataIndex: "code",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_plan_maintenance_equipment_name_jian"),
          dataIndex: "name",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_plan_maintenance_equipment_type_jian"),
          dataIndex: "deviceTypeName",
          ellipsis: true,
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t("page_product_specification_and_model_jian"),
          dataIndex: "standardModel",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_user_data"),
          dataIndex: "serviceDate",
          ellipsis: true,
          width: 200,
        },
        {
          title: this.$t("page_device_user_duration_jian"),
          dataIndex: "serviceLife",
          ellipsis: true,
          width: 120,
        },
        {
          title: this.$t("page_device_last_maintenance"),
          dataIndex: "lastMaintainTime",
          ellipsis: true,
          width: 150,
        },
        {
          title: this.$t("page_device_last_RepairTime"),
          dataIndex: "lastRepairTime",
          ellipsis: true,
          width: 150,
        },
        {
          title: this.$t("page_device_last_spotcheck"),
          dataIndex: "lastCheckTime",
          ellipsis: true,
          width: 150,
        },
        {
          title: this.$t("page_device_maintainStatus"),
          dataIndex: "maintainStatus",
          ellipsis: true,
          width: 150,
        },
        {
          title: this.$t("page_device_repairStatus"),
          dataIndex: "repairStatus",
          ellipsis: true,
          width: 150,
        },
        {
          title: this.$t("remark"),
          dataIndex: "remark",
          ellipsis: true,
          width: 150,
        },
      ];
    },
  },
  created() {
    this.tabs = [
      this.$t("page_repair_record"),
      this.$t("page_device_maintenance_records"),
      this.$t("page_equipment_maintenance_plan"),
      this.$t("page_tpm_check_record"),
      this.$t("page_device_spare_condition"),
    ];
    this.getDeviceList();
    this.pageDeviceType();
  },
  // watch: {
  //   pagination: {
  //     handler(val) {
  //       this.pagination.showTotal = (total) => {
  //         return this.$t("Total…items").replace("{0}", ` ${val.total} `);
  //       };
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    pageIndexchange(currentPage) {
      this.pagination.current = currentPage;
      this.getDeviceList()
    },
    totalFanyi(number) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    print() {
      this.getList()
      this.showCode = true;
    },
    cancel() {
      this.showCode = false;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
     getList() {
    //重组拿到的数据，分为code和name
    this.dataListArr = []
    this.dataList.map(itm =>{
      this.selectedRowKeys.map(item => {
        if(itm.id === item) {
          this.dataListArr.push({
            code: itm.code,
            name: itm.name
          })
        }
      })
    })
  },
    onSelectAll(selected, selectedRows, changeRows) {
      this.exportTypeId = [];
      selectedRows.forEach((item) => {
        this.exportTypeId.push(item.id);
      });
    },
    onSelect(record, selected, selectedRows) {
      this.exportTypeId = [];
      selectedRows.forEach((item) => {
        this.exportTypeId.push(item.id);
      });
    },
    closeModal(flag) {
      this.visible = false;
      if (flag) {
        this.getDeviceList();
      }
    },
    createEdit(type) {
      this.modalType = type ? type : "add";

      if (this.modalType === "edit") {
        this.shows = false;
        this.deviceDetail();
      } else {
        this.shows = true;
        this.visible = true;
      }

      // this.$refs.Edit.showCreate();
    },
    openMaintenanceProgram(e, record) {
      // e.stopPropagation();
      this.MaintenanceVisible = true;
      this.maintenanceId = record.deviceTypeId;
    },
    closeMaintenanceProgram() {
      this.MaintenanceVisible = false;
    },
    openSpotCheckProgram(e, record) {
      // e.stopPropagation();
      this.SpotCheckProgramVisible = true;
      this.spotCheckId = record.deviceTypeId;
    },
    closeSpotCheckProgram() {
      this.SpotCheckProgramVisible = false;
    },
    openPictureProgram(e, record) {
      // e.stopPropagation();
      this.PictureProgramVisible = true;
      this.workStationId = record.id;
    },

    closePictureProgram() {
      this.PictureProgramVisible = false;
    },
    searchForm() {
      this.pagination.current = 1;
      this.getDeviceList();
    },
    exportDevices() {
      if (this.exportTypeId.length) this.exportDevice();
    },
    async getDeviceList() {
      this.deviceList = [];
      // this.pagination.current = 1
      let object = {
        deviceTypeId: this.typeId,
        filter: this.keyWords,
        tenantId: getLocalStorage("USER_INFO").tenant_id,
      };
      var All = await deviceServiceProxy.getPageDevices(
        this.pagination.current,
        object,
        this.pagination.pageSize
      );
      this.dataList = All.records;
      this.pagination.total = All.total;
      // this.pagination.current = All.current;
      // this.pagination.size = All.size;
      if (this.dataList) {
        this.dataList.forEach((item) => {
          switch (item.maintainStatus) {
            case 1:
              item.maintainStatus = this.$t("page_device_normal");
              break;
            case 2:
              item.maintainStatus = this.$t(
                "page_plan_maintenance_to_be_maintained"
              );
              break;
            case 3:
              item.maintainStatus = this.$t("page_device_under_maintenance");
              break;
            case 4:
              item.maintainStatus = this.$t("page_device_to_be_confirmed");
              break;
          }
          switch (item.repairStatus) {
            case 1:
              item.repairStatus = this.$t("page_device_normal");
              break;
            case 2:
              item.repairStatus = this.$t("page_device_to_be_repaired");
              break;
            case 3:
              item.repairStatus = this.$t("page_device_under_repair");
              break;
            case 4:
              item.repairStatus = this.$t("page_device_to_be_confirmed");
              break;
          }
          if (item.lastCheckTime) {
            item.lastCheckTime = dayjs(item.lastCheckTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          if (item.lastMaintainTime) {
            item.lastMaintainTime = dayjs(item.lastMaintainTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          if (item.lastRepairTime) {
            item.lastRepairTime = dayjs(item.lastRepairTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          if (item.serviceDate) {
            item.serviceDate = dayjs(item.serviceDate).format("YYYY-MM-DD");
            // this.localTime = dayjs().format("YYYY-MM-DD")
            // // console.log("time:",localTime)
            // let Time  = Math.floor(dayjs(this.loacalTime).diff(dayjs(item.serviceDate),"day")/30)
            // if(Time<1){
            //   item.serviceLife = 0
            // }else{
            //   item.serviceLife =Time
            // }
            // console.log("11111",Time)
          } else {
            item.serviceDate = "";
            // item.serviceLife = "";
          }
          // console.log("zasd",item.lastRepairTime)
        });
      }
      // console.log("sdfasdf", this.dataList[0].maintainStatus);
      this.deviceId = "";
      // this.selectedRowKeys.splice(0, 1);
      this.selectedRowKeys = []
      this.exportTypeId = [];
      if (this.dataList.length) {
        this.selectedRowKeys.push(this.dataList[0].id);
        this.exportTypeId.push(this.dataList[0].id);
        this.deviceId = this.dataList[0].id;
        this.sparePartCode = this.dataList[0].code;
        this.sparePartName = this.dataList[0].name;
        this.sparePartType = this.dataList[0].deviceTypeName;
      }
    },
    async pageDeviceType() {
      let params = {
        keyWord: "",
        query: { current: 1, size: -1 },
      };
      let All = await deviceTypeServiceProxy.pageDeviceType(params);
      // console.log(All);
      this.typeList = [];
      All.records.map((item) => {
        this.typeList.push({ label: item.name, value: item.id });
        // return {label: item.name, value: item.id}
      });

      this.typeId = this.typeList[0].value;
      // console.log("typeList:", this.typeList);
      this.newTypeList.push({
        label: this.$t("page_plan_maintenance_all_types"),
        value: "",
      });
      All.records.map((item) => {
        this.newTypeList.push({ label: item.name, value: item.id });
        // return {label: item.name, value: item.id}
      });
      this.typeId = this.newTypeList[0].value;
      // console.log("qqqqqqq",this.newTypeList)
      this.getDeviceList();
    },
    handleTypeChange(a) {
      this.typeId = a;
      this.pagination.current = 1;
      this.getDeviceList();
    },
    scrollY() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(function() {
        this.tableScrollHeight = document.querySelector(".body").clientHeight;
        this.processScrollHeight = document.querySelector(
          ".footer-container"
        ).clientHeight;
        const bodyTableBody = document.querySelector(".body .ant-table-body");
        if (bodyTableBody) {
          bodyTableBody.style.maxHeight = this.tableScrollHeight - 88 + "px";
          this.tableScrollY = this.tableScrollHeight - 88;
        }
        const processTableBody = document.querySelector(
          ".process-table .ant-table-body"
        );
        if (processTableBody) {
          processTableBody.style.maxHeight =
            this.processScrollHeight - 150 + "px";
        }
      }, 100);
    },
    async deviceDetail() {
      let All = await deviceServiceProxy.deviceDetail(this.selectedRowKeys[0]);
      this.editItem = All;
      this.visible = true;
    },
    async exportDevice() {
      let param = {
        ids: this.exportTypeId,
      };
      let result = await exportDevice(param);
      downloadFile(result, "设备信息.xlsx");
    },
    rowClick(record) {
      return {
        on: {
          click: (event) => {
            this.exportTypeId = [];
            this.deviceId = record.id;
            this.sparePartCode = record.code;
            this.sparePartName = record.name;
            this.sparePartType = record.deviceTypeName;
            this.exportTypeId.push(record.id);
            this.selectedRowKeys = [];
            this.selectedRowKeys.push(record.id);
            // console.log("zzzzzzzzzzz",this.sparePartType)
          },
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-table-pagination.ant-pagination {
  margin: 8px 0;
}

.product-main {
  height: 100%;
  width: 100%;
  padding-top: 8px;
  .title {
    height: 32px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .table-panel {
    height: 100%;
  }
}

/deep/ .ant-dropdown-menu-item {
  width: 100%;
  display: flex;
  justify-content: center;
  .place-button {
    width: 100%;
  }
}
</style>
